import { useMemo } from "react";

const grades = [8, 9, 10, 11, 12];

const useGrades = () => {
  return useMemo(
    () => ({
      grades,
      gradeOptions: [
        ...grades.map((grade) => ({ key: grade, value: String(grade), text: grade })),
        { key: "student", value: "student", text: "Esu studentas" },
      ],
    }),
    []
  );
};

export default useGrades;
